import React from 'react';
import { ClipboardList, BookOpen, Calculator, FolderOpen, Building2, Gift, Share2 } from 'lucide-react';
import RevealOnScroll from '../RevealOnScroll';

const FeaturesSection = () => {
  const features = [
    {
      icon: ClipboardList,
      title: 'Creates Your Plan',
      description: 'Automatically generates a customized task list based on your estate. Tracks due dates and links to key probate forms.',
    },
    {
      icon: BookOpen,
      title: 'Explains Your Duties',
      description: 'Comprehensive guides describe the overall process with state-specific requirements, examples, and references.',
    },
    {
      icon: Calculator,
      title: 'Simplifies Accounting',
      description: 'Calculates estate value, tracks income and expenses, computes executor compensation and distributions.',
    },
    {
      icon: FolderOpen,
      title: 'Centralizes Information',
      description: 'Organize everything in one place. Store copies of the will, attach files to assets, heirs, and transactions.',
    },
    {
      icon: Building2,
      title: 'Imports from Bank',
      description: 'Optionally download directly from your bank. Automatically identifies distributions and debt payments.',
    },
    {
      icon: Share2,
      title: 'Share & Collaborate',
      description: 'Share access online with other executors, probate lawyers, or heirs. Assign edit or view permissions.',
    },
  ];

  return (
    <section className="section-padding bg-white" data-testid="features-section">
      <div className="container-custom">
        {/* Section Header */}
        <RevealOnScroll className="max-w-3xl mb-16">
          <span className="text-sm font-medium text-ep-secondary tracking-wide uppercase mb-4 block">
            Features
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-ep-text mb-6">
            Everything you need to{' '}
            <span className="italic text-ep-primary">settle an estate</span>
          </h2>
          <p className="text-lg text-ep-text-secondary">
            From initial inventory to final distribution, EstateProFiler guides you through 
            every step of the probate process.
          </p>
        </RevealOnScroll>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <RevealOnScroll key={index} delay={(index % 3) * 100}>
              <div 
                className="group p-8 rounded-2xl border border-ep-border bg-ep-background hover:bg-white hover:shadow-lifted transition-all duration-300 h-full"
                data-testid={`feature-card-${index}`}
              >
                <div className="w-12 h-12 rounded-xl bg-ep-primary/10 flex items-center justify-center mb-6 group-hover:bg-ep-primary group-hover:scale-110 transition-all duration-300">
                  <feature.icon className="w-6 h-6 text-ep-primary group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-ep-text mb-3">
                  {feature.title}
                </h3>
                <p className="text-ep-text-secondary leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
